import DialogModal from "components/DialogModal";
import { Field } from "formik";
import { AddIcon, ClearIcon, GrayQRCode } from "assets/icon";
import Select from 'react-select';
import Utils from "utils";
function ProductModal({
  openDialog,
  handleCloseDialog,
  intl,
  handleSubmit,
  initialValues,
  isAdd,
  filesImage,
  handleRemoveImage,
  handleImage,
  handleOnchangeImage,
  selectStyle,
  selectOptions,
  handleSelectGinseng,
  productData,
  showQrImage,
  unit,
}) {


  return (
    <DialogModal
      openDialog={openDialog}
      handleCloseDialog={handleCloseDialog}
      handleSubmit={handleSubmit}
      headerTitle={isAdd ? intl.messages.createProduct : intl.messages.updateProduct}
      submitName={isAdd ? intl.messages.add : intl.messages.update}
      cancelName={intl.messages.cancel}
      initialValues={isAdd ? initialValues : {
        id: productData.id,
        name: productData.name,
        qr_code: productData.qr_code,
        created_at: Utils.formatDateYDM(productData.created_at),
        unit_value: productData.unit_value,
        description: productData.description,
        other_information: productData.other_information,
        checkbox: productData.unit_id !== unit[0].id,
        qr: productData.qr_code_base64,
        ginseng_id: productData.ginseng_products[0]?.ginseng_id,
        manufactureDate: productData.manufacture_date,
      }}
    >
      <div className="sub-header">{intl.messages.generalInformation}</div>
      <div style={{ display: "flex" }}>
        <div
          className="input-container"
          style={{ marginRight: "16px", width: "47%" }}
        >
          <Field
            className="input-container__input"
            id="qr_code"
            name="qr_code"
            type="text"
            placeholder={intl.messages.productIdPH}
          />
          <label htmlFor="qr_code" className="input-container__title required">
            {intl.messages.productId}
          </label>
        </div>
        <div className="input-container">
          <Field
            className="input-container__input"
            id="name"
            name="name"
            type="text"
            placeholder={intl.messages.productNamePH}
          />
          <label htmlFor="name" className="input-container__title required">
            {intl.messages.productName}
          </label>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="input-container" style={{ width: "47%" }}>
          <label className="link-label">
            <Field name="created_at" htmlFor="created_at" >
              {({ field }) => (
                <>
                  <span className="date-icon" />
                  <span className="silver-text">{field.value}</span>
                  <input className="input-container__input"
                    id="created_at"
                    type="date"
                    style={{ display: "none" }} />
                </>
              )}
            </Field>
          </label>
          <label className="input-container__title">
            {intl.messages.dateCreated}
          </label>
        </div>
        <div className="input-container" style={{ marginRight: "16px", marginLeft: "16px", width: "47%" }}>
          <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between' }}>
            <label className="toggle-container">
              <Field name="checkbox" type="checkbox" className="toggle-input" />
              <div className="toggle-switch-s">
                <span>ml</span>
                <span>cc</span>
                <div className="toggle-handle" />
              </div>
            </label>
            <Field
              style={{ width: '65%' }}
              className="input-container__input"
              id="unit_value"
              name="unit_value"
              type="number"
              placeholder={intl.messages.productUnitPH}
            />
          </div>
          <label htmlFor="unit_value" className="input-container__title required">
            {intl.messages.unit}
          </label>
        </div>
        <div className="input-container disable-background" style={{ width: "47%" }}>
          <label className="link-label" style={{ cursor: "pointer" }}>
            <Field name="qr" htmlFor="qr"  >
              {({ field, form }) => (
                <>
                  <GrayQRCode />
                  <span style={{ color: '#0288d1' }} onClick={() => showQrImage(field.value, form.values.qr_code)}>{intl.messages.viewQr}</span>
                </>
              )}
            </Field>

          </label>
          <label className="input-container__title disable-text">
            {intl.messages.qrCode}
          </label>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="input-container" style={{ marginRight: "16px", width: "47%" }}>
          <Field
            className="input-container__input"
            id="manufactureDate"
            name="manufactureDate"
            type="date"
          />
          <label htmlFor="manufactureDate" className="input-container__title required">
            {intl.messages.manufactureDate}
          </label>
        </div>
        <div
          className="input-container"
        >
          <Field name="ginseng_id" htmlFor="ginseng_id" >
            {({ field }) => (
              <>
                <Select
                  options={selectOptions}
                  onChange={handleSelectGinseng}
                  isSearchable={true}
                  defaultValue={selectOptions.filter(({ value }) => value === field.value)}
                  components={{
                    IndicatorSeparator: () => null
                  }}
                  placeholder={intl.messages.searchGinseng}
                  styles={selectStyle}
                />
              </>
            )}
          </Field>
          <label htmlFor="ginseng_id" className="input-container__title">
            {intl.messages.ginsengLink}
          </label>
        </div>
      </div>
      <div className="sub-header">{intl.messages.detailInfo}</div>
      <div style={{ display: "flex" }}>
        <div className="input-container-area" style={{ marginRight: "16px" }}>
          <Field
            as='textarea'
            className="input-container__input"
            style={{ height: "65px" }}
            id="description"
            name="description"
            type="text"
            placeholder={intl.messages.otherEffect}
          />
          <label
            htmlFor="description"
            className="input-container__title required"
          >
            {intl.messages.ginsengEffect}
          </label>
        </div>
        <div className="input-container-area">
          <Field
            as='textarea'
            className="input-container__input"
            style={{ height: "65px" }}
            id="other_information"
            name="other_information"
            type="text"
            placeholder={intl.messages.otherInfoPH}
          />
          <label htmlFor="other_information" className="input-container__title">
            {intl.messages.otherInfo}
          </label>
        </div>
      </div>
      <div className="card-container resize-height">
        <div style={{ display: "flex" }}>
          {filesImage.map((item, index) => {
            return (
              <div style={{ position: "relative" }} key={`image-${index}`}>
                <div
                  className="remove-image-btn"
                  onClick={() => handleRemoveImage(item)}
                >
                  <ClearIcon />
                </div>
                <img
                  className="card-container__image-preview"
                  src={handleImage(item)}
                  alt={'error'}
                />
              </div>
            );
          })}
          {filesImage.length < 5 && (
            <div
              className="upload-box"
              onClick={() => document.getElementById("getFiles").click()}
            >
              <AddIcon />
            </div>
          )}
        </div>
        <input
          accept="image/jpeg, image/png, image/jpg"
          id="getFiles"
          type="file"
          style={{ display: "none" }}
          onChange={handleOnchangeImage}
        />
        <label
          className={`card-container__title ${filesImage.length < 1 && `required`}`}
          style={{ marginBottom: "0px", color: "#3b927d" }}
        >
          {intl.messages.ginsengImage}
        </label>
      </div>
    </DialogModal>
  );
}

export default ProductModal;
